/**
 * Scrolls to the invalid question in the UI
 */
export const scrollToInvalidQuestion = (refId: string) => {
	const editElement = document.getElementById(`question-${refId}`);
	editElement?.scrollIntoView({ behavior: "smooth", block: "start" });
};
